import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=1a14caf2&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=ts&"
export * from "./ContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=1a14caf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a14caf2",
  null
  
)

export default component.exports